"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const Box_1 = __importDefault(require("@material-ui/core/Box"));
const Button_1 = __importDefault(require("@material-ui/core/Button"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const Dialog_1 = __importDefault(require("@material-ui/core/Dialog"));
const DialogActions_1 = __importDefault(require("@material-ui/core/DialogActions"));
const DialogContent_1 = __importDefault(require("@material-ui/core/DialogContent"));
const formik_1 = require("formik");
const RenderTextField_1 = __importDefault(require("./RenderTextField"));
const core_1 = require("@material-ui/core");
const Email_1 = __importDefault(require("@material-ui/icons/Email"));
const RenderCheckboxField_1 = __importDefault(require("./RenderCheckboxField"));
const utils_1 = require("../utils");
const useStyles = core_1.makeStyles((theme) => ({
    dialogContent: {
        flexDirection: 'row',
        justifyContent: 'center',
        flexWrap: 'wrap',
    },
    icon: {
        fontSize: '45px',
    },
    selectBoard: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-evenly',
    },
    errorMessage: {
        color: '#f44336',
        fontSize: '14px',
    },
    dialogDiv: {
        maxWidth: '750',
        display: 'flex',
        justifyContent: 'center',
    },
    mailIcon: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
    },
}));
const ModalNewsLetter = (props) => {
    var _a, _b, _c, _d;
    const classes = useStyles();
    const { onCancel, isVisible, validationSchema, email, userName, submitData, preferences } = props;
    const handleSubmit = (values) => {
        const { lwb, rboard, agree, ...dataToSent } = values;
        preferences.length > 0
            ? submitData({ ...dataToSent }, utils_1.NewsLetterSubmissionType.Update)
            : submitData({ ...dataToSent }, utils_1.NewsLetterSubmissionType.Submit);
        onCancel({ lwb, rboard }, 'success');
    };
    const handleCheckBox = (event, value, values, setFieldValue) => {
        values.options[event.target.name] = value;
        setFieldValue('options', values.options);
    };
    const termsText = (react_1.default.createElement(react_1.default.Fragment, null,
        "I have read and agree to the",
        react_1.default.createElement("a", { rel: "noreferrer", target: "_blank", href: process.env.GATSBY_PRIVACY_TERMS_USE_PDF_URL }, "Terms of Use and Privacy Policy")));
    return (react_1.default.createElement(Dialog_1.default, { open: isVisible, onClose: onCancel, fullWidth: true, maxWidth: 'md' },
        react_1.default.createElement("div", { 
            /* style={{width: '750px', display: 'flex', justifyContent: 'center'}} */ style: {
                display: 'flex',
                justifyContent: 'center',
            } },
            react_1.default.createElement(formik_1.Formik, { initialValues: {
                    username: userName,
                    email: email,
                    options: {
                        lwb: preferences ? (((_a = preferences[0]) === null || _a === void 0 ? void 0 : _a.lwb) === true ? true : false) : false,
                        rboard: preferences ? (((_b = preferences[0]) === null || _b === void 0 ? void 0 : _b.rboard) === true ? true : false) : false,
                    },
                    agree: false,
                    lwb: preferences ? (((_c = preferences[0]) === null || _c === void 0 ? void 0 : _c.lwb) === true ? true : false) : false,
                    rboard: preferences ? (((_d = preferences[0]) === null || _d === void 0 ? void 0 : _d.rboard) === true ? true : false) : false,
                }, validationSchema: validationSchema, onSubmit: handleSubmit, enableReinitialize: true }, ({ submitForm, values, setFieldValue }) => {
                var _a, _b;
                return (react_1.default.createElement(formik_1.Form, { style: { maxWidth: '600px' } },
                    react_1.default.createElement(DialogContent_1.default, null,
                        react_1.default.createElement(Box_1.default, { display: "flex", className: classes.dialogContent },
                            react_1.default.createElement(Box_1.default, { className: classes.mailIcon },
                                react_1.default.createElement(Typography_1.default, { variant: "h1" },
                                    react_1.default.createElement(Email_1.default, { className: classes.icon, fontSize: "large" }))),
                            react_1.default.createElement(Typography_1.default, { variant: "h1", style: { fontSize: '30px', textAlign: 'center' } },
                                "Subscribe to our Newsletter and ",
                                react_1.default.createElement("br", null),
                                " stay up to date!"),
                            react_1.default.createElement(Box_1.default, { className: classes.selectBoard },
                                react_1.default.createElement(formik_1.Field, { name: "lwb", text: "Land and Water Boards (LWBs)", checkedValue: preferences ? (((_a = preferences[0]) === null || _a === void 0 ? void 0 : _a.lwb) === true ? true : false) : false, component: RenderCheckboxField_1.default, onValueChange: (event, value) => handleCheckBox(event, value, values, setFieldValue), textStyle: { paddingBottom: '0px' } }),
                                react_1.default.createElement(formik_1.Field, { name: "rboard", text: "Review Board", checkedValue: preferences ? (((_b = preferences[0]) === null || _b === void 0 ? void 0 : _b.rboard) === true ? true : false) : false, component: RenderCheckboxField_1.default, onValueChange: (event, value) => handleCheckBox(event, value, values, setFieldValue), textStyle: { paddingBottom: '0px' } })),
                            react_1.default.createElement(Typography_1.default, { className: classes.errorMessage },
                                react_1.default.createElement(formik_1.ErrorMessage, { name: "options" })),
                            react_1.default.createElement(Box_1.default, { style: { width: '75%', margin: '20px' } },
                                react_1.default.createElement(formik_1.Field, { name: 'email', label: 'Email (required)', component: RenderTextField_1.default, disabled: true }),
                                react_1.default.createElement(formik_1.Field, { name: 'username', label: 'Name (required)', component: RenderTextField_1.default, style: { marginTop: '0.625rem' }, disabled: true })),
                            react_1.default.createElement(Box_1.default, null,
                                react_1.default.createElement(formik_1.Field, { name: "agree", text: termsText, defaultValue: false, component: RenderCheckboxField_1.default, textStyle: { fontSize: '14px', color: 'gray', paddingBottom: '0px' }, style: { color: 'gray', transform: 'scale(1.1)' } }),
                                react_1.default.createElement(Typography_1.default, { className: classes.errorMessage },
                                    react_1.default.createElement(formik_1.ErrorMessage, { name: "agree" }))))),
                    react_1.default.createElement(DialogActions_1.default, { style: { marginBottom: '1rem', maxWidth: '100%' } },
                        react_1.default.createElement(Button_1.default, { variant: "contained", color: "secondary", style: { maxHeight: '30px', minWidth: '160px' }, onClick: onCancel }, "I'll think about it"),
                        react_1.default.createElement(Button_1.default, { variant: "contained", color: "primary", style: { maxHeight: '30px' }, onClick: submitForm }, "Subscribe"))));
            }))));
};
ModalNewsLetter.propTypes = {
    onCancel: prop_types_1.default.any,
    isVisible: prop_types_1.default.any,
    validationSchema: prop_types_1.default.any,
    email: prop_types_1.default.string,
    userName: prop_types_1.default.string,
    submitData: prop_types_1.default.any,
    preferences: prop_types_1.default.any,
};
exports.default = ModalNewsLetter;
